var _path, _path2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLinesDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 470,
    viewBox: "0 0 240 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 50.002L195 8.00195L88 118.502L195 233.002L233 191.002L164.5 118.502L233 50.002Z",
    stroke: "url(#paint0_linear_1659_36)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 349.002L45 391.002L152 280.502L45 166.002L7 208.002L75.5 280.502L7 349.002Z",
    stroke: "url(#paint1_linear_1659_36)",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.0711,
    y: 429.307,
    width: 47,
    height: 47,
    transform: "rotate(-45 78.0711 429.307)",
    stroke: "url(#paint2_linear_1659_36)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1659_36",
    x1: 160.5,
    y1: 8.00195,
    x2: 160.5,
    y2: 233.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499999,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "#112E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#001A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1659_36",
    x1: 79.5,
    y1: 391.002,
    x2: 79.5,
    y2: 166.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499999,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "#112E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#001A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1659_36",
    x1: 99.5,
    y1: 429.307,
    x2: 99.5,
    y2: 486.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#13142B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLinesDark);
export default __webpack_public_path__ + "static/media/blueLinesDark.974a11412f9771f5d84048829571d6d5.svg";
export { ForwardRef as ReactComponent };